export default __webpack_public_path__ + "static/media/image2.57e8a994.jpg";